import { getResolvedPath } from '../../../util/routing/entity-paths';

export const INVENTORY_SELL_DOWN_BASE_PATH = getResolvedPath('/clearing/operations/inventory/sell-down');
